import { createAction } from '@reduxjs/toolkit';
import { User } from 'api/models';

export const fetchCurrentUserProfileSagaAction = createAction(
  'currentUserProfile/getCurrentUserProfile',
);

export interface SaveCurrentUserPayload {
  user: AtLeast<User, 'userId'>;
  handleSuccess?(): void;
  handleError?(): void;
  handleAlways?(): void;
}
export const saveCurrentUserProfileSagaAction =
  createAction<SaveCurrentUserPayload>(
    'currentUserProfile/saveCurrentUserProfile',
  );
